import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Redirect} from 'react-router-dom';
import {withRouter} from 'react-router';
import propTypes from 'prop-types';
import * as Actions from '../actions';
import lang from '../constants/Languages.js';

//import components
import SearchForm from '../components/search/SearchForm.js';
import SearchLinks from '../components/search/SearchLinks.js';
import MainPageHeadingsInfo from '../components/main-page/MainPageHeadingsInfo.js';

//import helper methods
import * as CheckPathname from '../scripts/CheckPathname.js';
import * as BuildQuery from '../scripts/ResultsFiltersQueryBuild.js';

//img
import pblLogo from '../assets/icons/pbl-logo.svg';
import pblLogoContrast from '../assets/icons/pbl-logo-white.svg';

class Search extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fireRedirect: false,
            query: '',
            area: ''
        };
    };

    componentDidMount() {
        const {location, actions} = this.props;

        if (CheckPathname.isMainPage(location)) {
            actions.getMainPageHeadingsInfo();
        }
    };

    componentWillReceiveProps(nextProps) {
        const {actions} = this.props;

        //prevents unexpected redirect when going back
        if (nextProps.location !== this.props.location) {
            this.setState({fireRedirect: false});

            if (CheckPathname.isMainPage(nextProps.location)) {
                actions.getMainPageHeadingsInfo();
            }
        }
    };

    submitForm = (values) => {
        const {isLoading} = this.props;

        if (isLoading) {
            return;
        }

        this.submitFormAction(values);
    };

    submitFormAction = (values) => {
        const {location, isBlocked, tabs, actions, history, appliedFilters} = this.props;

        if (CheckPathname.isResultsPage(location) || CheckPathname.isFilesSearch(location) || CheckPathname.isRecordsSearch(location)) {
            const activeTab = tabs.filter(tab => tab.active)[0];

            if (!activeTab) {
                history.push({
                    search: `?q=${values.key.trim()}&area=all`
                });
            } else {
                const activeTabName = activeTab.name;
                const filters = BuildQuery.buildQuery(activeTabName, appliedFilters);

                actions.resetTabNav();

                if (!isBlocked) {
                    actions.resetFilters();
                    history.push({
                        search: `?q=${values.key.trim()}&area=${values.area.value.trim()}`
                    });
                }

                if (isBlocked && tabs) { 
                    history.push({
                        search: `?q=${values.key.trim()}&area=${values.area.value.trim()}&tab=${activeTabName}${filters}`
                    });
                }
            }
        } 

        if (!CheckPathname.isResultsPage(location) && !CheckPathname.isRecordsSearch(location) && !CheckPathname.isFilesSearch(location)) {
            //redirects to results with new query
            this.setState({
                fireRedirect: true,
                query: values.key.trim(),
                area: values.area.value.trim()
            });
        }
    };

    getLogoSection = () => {
        const { clang } = this.props;

        return <div className="search-bar__logo-section">
                   <img src={pblLogo} alt={lang[clang].alt.logo} className="search-bar__logo-img"/>
                   <img src={pblLogoContrast} alt={lang[clang].alt.logo} className="search-bar__logo-img contrast"/>
                   <div className="search-bar__logo-container">
                      <p dangerouslySetInnerHTML={{__html: lang[clang].main_page.about}} className="search-bar__logo-desc"></p>
                   </div>
               </div>;
    };

    getKey = () => {
        const {searchParams, location} = this.props;

        const isHeadingsDetails = CheckPathname.isHeadingsDetails(location);
        const isRecordsSearch = CheckPathname.isRecordsSearch(location) && searchParams.key === '*';
        const isFilesSearch = CheckPathname.isFilesSearch(location);
        const isAdvancedSearchResults = CheckPathname.isAdvancedSearchResults(location);

        if (searchParams.key === "*" && (isFilesSearch || isRecordsSearch || isHeadingsDetails)) {
            return '';
        }

        if (isAdvancedSearchResults) {
            return '';
        }

        return searchParams.key;
    };

    render() {
        const {searchParams, location, searchOptions, searchOptionsFiles, clang, searchHeadingsInfo, currentKey, isOnlyForm, isLoading} = this.props;
        const {fireRedirect, query, area} = this.state;
        const from = location.state || '/';
        const isMainPage = CheckPathname.isMainPage(location) ? 'main-search' : '';
        const isFilesSearch = CheckPathname.isFilesSearch(location);

        //initial values for search form from store
        const initialValues = {
            key: this.getKey(),
            area: {value: searchParams.area, label: lang[clang].search.options[searchParams.area]}
        };

        return (
            <section className={`search-bar ${isMainPage}`}>
                <div className="search-bar__container">
                    {CheckPathname.isMainPage(location) && this.getLogoSection()}
                    {!CheckPathname.isAdvancedSearch(location) &&
                        <div>
                            <SearchForm
                                initialValues={initialValues}
                                isFilesSearch={isFilesSearch}
                                onSubmit={this.submitForm}
                                searchOptions={searchOptions}
                                searchOptionsFiles={searchOptionsFiles}
                                isLoading={isLoading}
                                currentKey={currentKey.search && currentKey.search.values ? currentKey.search.values.key : false}
                                isMainPage={CheckPathname.isMainPage(location)}/>
                            {!isOnlyForm && <SearchLinks />}
                        </div>}
                </div>
                {CheckPathname.isMainPage(location) && searchHeadingsInfo &&
                    <MainPageHeadingsInfo data={searchHeadingsInfo}/>}
                {fireRedirect &&
                    <Redirect push to={{
                        pathname: '/results',
                        // pathname: isFilesSearch ? '/files/search' : '/results',
                        search: `?q=${query}&area=${area}`,
                        state: {
                            referrer: from
                        }
                    }}/>}
            </section>
        );
    };
};

Search.propTypes = {
    actions: propTypes.object.isRequired,
    history: propTypes.object.isRequired,
    clang: propTypes.string.isRequired,
    location: propTypes.shape({
        pathname: propTypes.string
    }),
    searchParams: propTypes.shape({
        key: propTypes.string
    }),
    searchOptions: propTypes.arrayOf(
        propTypes.shape({
            id: propTypes.number,
            name: propTypes.string
        })
    ),
    searchOptionsFiles: propTypes.arrayOf(
        propTypes.shape({
            id: propTypes.number,
            name: propTypes.string
        })
    ),
    searchHeadingsInfo: propTypes.arrayOf(
        propTypes.shape({
            recordsNumber: propTypes.number
        })
    ),
    isBlocked: propTypes.bool.isRequired,
    appliedFilters: propTypes.arrayOf(
        propTypes.shape({
            id: propTypes.string.isRequired,
            label: propTypes.string.isRequired,
            value: propTypes.array,
            tab: propTypes.string
        })
    ),
    tabs: propTypes.arrayOf(
        propTypes.shape({
            name: propTypes.string.isRequired,
            count: propTypes.number.isRequired,
            active: propTypes.bool.isRequired,
            page: propTypes.number,
            perPage: propTypes.number,
            sorting: propTypes.string,
        })
    ),
};

const mapStateToProps = state => ({
    searchParams: state.search.searchParams,
    searchOptions: state.search.searchOptions,
    searchOptionsFiles: state.search.searchOptionsFiles,
    isBlocked: state.simpleSearchResults.isBlocked,
    tabs: state.simpleSearchResults.tabs,
    isLoading: state.simpleSearchResults.isFetching,
    appliedFilters: state.simpleSearchResults.appliedFilters,
    searchHeadingsInfo: state.mainPage.searchHeadingsInfo,
    clang: state.language.currentLanguage,
    currentKey: state.form
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Search));



// WEBPACK FOOTER //
// ./src/containers/Search.js